import { FC, HTMLAttributes } from 'react';
import clx from "classnames";
import MaskInput from 'src/Components/Controls/MaskInput/MaskInput';
import DateFormater from 'src/Utils/DateFormater';
import { getToday, isValidDate } from '../utils';
import st from "./CalendarInputs.module.scss";

interface ICalendarInputsProps extends HTMLAttributes<HTMLDivElement> {
	/** Только для чтения */
	readOnly?: boolean;
	/** Первое значение диапазона */
	firstValue: Date | null;
	/** Второе значение диапазона */
	lastValue: Date | null;
	/** Флаг указывающий что активный ввод первой даты */
	isFirst?: boolean;
	/** Вызывается при вводе значения */
	onChangeValue: ( value: Date | null, isFirst?: boolean ) => void;
	/** Вызывается при смены режима ввода диапазона */
	onChangeBetweenChangeType: ( index: number ) => void;
};

/** Компонента отображает переключение диапазона и ввод дат по маске */
const CalendarInputs: FC<ICalendarInputsProps> = ( props ) => {

	const {
		readOnly, firstValue, lastValue, isFirst = true,
		onChangeValue, onChangeBetweenChangeType,
		className, ...otherProps
	} = props;

	/** Устанавливает значение по указанному индексу  */
	const onChangeValueByInput = ( val: string, isFirst: boolean = true ) => {
		if ( !val ) {
			onChangeValue( null, isFirst );
			return;
		}
		const parsedValue = DateFormater.parseDate( val, true );
		const newValue = isValidDate( parsedValue ) ? parsedValue : getToday();
		onChangeValue( newValue, isFirst );
	};

	return (
		<div className={clx(st.inputsBlock, className)} {...otherProps}>
			<MaskInput
				disabled={readOnly}
				mask="99.99.9999" 
				placeholder="ДД.ММ.ГГГГ" 
				setValue={onChangeValueByInput}
				onClick={ () => onChangeBetweenChangeType( 0 ) }
				value={DateFormater.toShortString( firstValue )} 
				className={ clx(st.inputsBlock__Input, { [st.active]: isFirst })}
				isClearBtn
			/>
			{"-"}
			<MaskInput 
				disabled={readOnly}
				mask="99.99.9999" 
				placeholder="ДД.ММ.ГГГГ" 
				onClick={ () => onChangeBetweenChangeType( 1 ) }
				value={ DateFormater.toShortString( lastValue )}
				setValue={ v => onChangeValueByInput(v, false) }
				className={ clx(st.inputsBlock__Input, { [st.active]: !isFirst })}
				isClearBtn
			/>			
		</div>
	);
};

export default CalendarInputs;
